<template>
  <input
    v-if="!disabled"
    class="input-count"
    aria-label="Поле ввода количества"
    type="text"
    v-bind:disabled="disabled"
    v-model="count"
    v-on:blur="onBlur"
    v-on:focus="onFocus"
    v-on:input="onInput"
  />
  <span v-else>{{ count }}</span>
</template>

<script>

/**
 * @description Название события ввода
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Название события потери фокуса
 * @type {string}
 */
const NAME_EVENT_BLUR = 'blur';

/**
 * Компонент ввода количества.
 * @type {Vue}
 */
export default {
  data() {
    return {
      count: this.value,
    };
  },
  methods: {
    /**
     * @description Обработать потерю фокуса.
     * @returns {void}
     */
    onBlur() {
      if (this.count === 0 || this.count === '') {
        this.count = this.min;
      }
      this.$emit(NAME_EVENT_BLUR, this.count);
    },
    /**
     * @description Обработать ввод.
     * @returns {void}
     */
    onInput() {
      this.formattingCount();
      this.$emit(NAME_EVENT_INPUT, this.count);
    },
    /**
     * @description Обработать фокус.
     * @returns {void}
     */
    onFocus() {
      if (this.count === 0) {
        this.count = '';
      }
    },
    /**
     * @description Форматирование количества.
     * @returns {void}
     */
    formattingCount() {
      const regexp = /[^\d]/g;
      const value = this.count.replace(regexp, '');
      if (value === '') {
        this.count = 0;
        return;
      }
      const format = /^[\d]{0,3}/g;
      let [result] = format.exec(value) || [this.value];
      if (this.max) {
        result = Math.min(Number(result), this.max);
      }
      this.count = Math.max(Number(result), 1);
    },
  },
  name: 'InputCount',
  props: {
    /**
     * Деактивирован.
     * @type {boolean}
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * Значение.
     * @type {number}
     */
    value: { type: Number, required: true },
    /**
     * Минимум.
     * @type {number}
     */
    min: { type: Number, default: () => 0 },
    /**
     * Максимум.
     * @type {number}
     */
    max: { type: Number, default: () => 1000 },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.count = newValue;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.input-count {
  max-width: 100%;
  padding: 5px;
  border: 1px solid var(--action-color);
  border-radius: 4px;
  &:focus {
    outline: 1px solid var(--action-color);
  }
  &:disabled {
    border-color: var(--unfocus-color);
  }
}

</style>
